export const BRAND = {
  name: "Andhra Biryani Co",
  tagline: "Andhra Style. Authentic Taste.",
  logoPrimary:
    "https://customer-assets.emergentagent.com/job_04207364-4bc9-4729-aac5-edbd1caa4e9a/artifacts/g3dwzpff_Andhra_Biryani_Logo.png",
  logoTransparent:
    "https://customer-assets.emergentagent.com/job_04207364-4bc9-4729-aac5-edbd1caa4e9a/artifacts/oqyj6d91_Andhra_Biryani_Logo-removebg-preview.png",
  heroPhoto:
    "https://customer-assets.emergentagent.com/job_04207364-4bc9-4729-aac5-edbd1caa4e9a/artifacts/kzbxcxvx_andhra_biryani.png",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "story", label: "Our Story" },
  { id: "menu", label: "Menu" },
  { id: "why-us", label: "Why Us" },
  { id: "gallery", label: "Gallery" },
  { id: "locations", label: "Store Locator" },
  { id: "franchise", label: "Franchise", route: "/franchise" },
  { id: "contact", label: "Contact" },
];

export const MENU_ITEMS = [
  {
    id: "andhra-chicken-dum",
    name: "Andhra Chicken Dum Biryani",
    tagline: "Signature slow-cooked classic",
    description:
      "Long-grain basmati layered with marinated chicken, Guntur red chilli, fried onions and saffron — sealed and dum-cooked in a clay handi.",
    price: 349,
    spice: 3,
    type: "non-veg",
    image:
      "https://images.unsplash.com/photo-1599043513900-ed6fe01d3833?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "gongura-mutton",
    name: "Gongura Mutton Biryani",
    tagline: "Tangy sorrel-leaf indulgence",
    description:
      "Tender mutton braised with gongura (sorrel) leaves, ginger and bone-marrow stock — earthy, tangy, intensely Andhra.",
    price: 449,
    spice: 3,
    type: "non-veg",
    image:
      "https://images.unsplash.com/photo-1697155406055-2db32d47ca07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "natu-kodi",
    name: "Hyderabadi Chicken Biryani",
    tagline: "Kacchi dum, saffron-kissed",
    description:
      "Classic Hyderabadi kacchi biryani — raw marinated chicken sealed under saffron basmati and dum-cooked with mint, fried onions and whole spices.",
    price: 419,
    spice: 3,
    type: "non-veg",
    image:
      "https://images.unsplash.com/photo-1589302168068-964664d93dc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ulavacharu",
    name: "Ulavacharu Biryani",
    tagline: "Horse-gram heritage broth",
    description:
      "Coastal Andhra delicacy — basmati cooked in slow-reduced horse-gram broth, finished with ghee and brown onions.",
    price: 379,
    spice: 2,
    type: "non-veg",
    image:
      "https://images.unsplash.com/photo-1716550781939-beb7d7247aae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "prawn-biryani",
    name: "Hyderabadi Til Mil Biryani",
    tagline: "The mixed-grill dum feast",
    description:
      "A Hyderabadi combination biryani — chicken, boti and egg layered together over saffron basmati and dum-sealed. One handi, every craving.",
    price: 469,
    spice: 2,
    type: "non-veg",
    image:
      "https://images.pexels.com/photos/12737919/pexels-photo-12737919.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "veg-dum",
    name: "Vegetable Dum Biryani",
    tagline: "Garden vegetables, royal dum",
    description:
      "Carrots, beans, paneer and cashews layered with saffron rice — slow-cooked under a sealed lid for that classic dum aroma.",
    price: 299,
    spice: 2,
    type: "veg",
    image:
      "https://images.unsplash.com/photo-1642821373181-696a54913e93?auto=format&fit=crop&w=900&q=70",
  },
];

export const WHY_US = [
  {
    title: "Recipes from Andhra",
    body: "Heirloom recipes from coastal Andhra kitchens — passed down, never diluted.",
    icon: "ScrollText",
  },
  {
    title: "Hand-Picked Spices",
    body: "Guntur chillies, single-origin cardamom and stone-ground masalas.",
    icon: "Flame",
  },
  {
    title: "Slow-Cooked Dum",
    body: "Sealed in handi, cooked over low flame — every grain holds its own.",
    icon: "Soup",
  },
  {
    title: "Daily, Never Stored",
    body: "Cooked fresh in small batches every single day. No reheating, ever.",
    icon: "Sparkles",
  },
];

export const TESTIMONIALS = [
  {
    name: "Aarav S.",
    city: "Hyderabad",
    quote:
      "The Gongura Mutton is a love letter to Andhra. Tangy, fiery, and falling-off-the-bone tender — this is the real thing.",
    rating: 5,
  },
  {
    name: "Lakshmi R.",
    city: "Bengaluru",
    quote:
      "Ulavacharu Biryani transported me back to my grandmother's kitchen in Vijayawada. Every grain was perfumed.",
    rating: 5,
  },
  {
    name: "Daniel P.",
    city: "Mumbai",
    quote:
      "I've eaten biryani across the country and this is in the top three. Spice level is unapologetic — exactly how it should be.",
    rating: 5,
  },
];

export const LOCATIONS = [
  {
    id: "jubilee",
    city: "Hyderabad",
    name: "Flagship",
    area: "Jubilee Hills, Hyderabad",
    address: "Plot 42, Road No. 36, Jubilee Hills, Hyderabad 500033",
    hours: "12:00 PM to 11:30 PM",
    phone: "+91 90000 00001",
    map:
      "https://images.pexels.com/photos/10135116/pexels-photo-10135116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "vijayawada",
    city: "Vijayawada",
    name: "Benz Circle",
    area: "Benz Circle, Vijayawada",
    address: "Door No. 27-1-50, MG Road, Benz Circle, Vijayawada 520010",
    hours: "11:30 AM to 11:00 PM",
    phone: "+91 90000 00002",
    map:
      "https://images.pexels.com/photos/12181619/pexels-photo-12181619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "bangalore",
    city: "Bengaluru",
    name: "Indiranagar",
    area: "Indiranagar, Bengaluru",
    address: "100 ft Road, 12th Main, Indiranagar, Bengaluru 560038",
    hours: "12:00 PM to 11:30 PM",
    phone: "+91 90000 00003",
    map:
      "https://images.pexels.com/photos/28411491/pexels-photo-28411491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "ranchi",
    city: "Ranchi",
    name: "Bariatu Outlet",
    area: "Bariatu, Ranchi",
    address: "Bariatu Road, Near Bariatu Chowk, Ranchi 834009",
    hours: "12:00 PM to 11:00 PM",
    phone: "+91 90000 00004",
    map:
      "https://images.pexels.com/photos/10135116/pexels-photo-10135116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const GALLERY = [
  "https://customer-assets.emergentagent.com/job_04207364-4bc9-4729-aac5-edbd1caa4e9a/artifacts/kzbxcxvx_andhra_biryani.png",
  "https://images.unsplash.com/photo-1599043513900-ed6fe01d3833?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1697155406055-2db32d47ca07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1716550781939-beb7d7247aae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/30296301/pexels-photo-30296301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/28411491/pexels-photo-28411491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1589302168068-964664d93dc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxiaXJ5YW5pJTIwZGlzaCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgxNDY2NDgzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/9609844/pexels-photo-9609844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];
